export const createPromise = (executor) => new Promise(executor);
export const when = (promise, resolve, reject) => {
    return promise.then(resolve, reject);
};
export const whenAll = (values) => Promise.all(values);
export const resolved = (val) => Promise.resolve(val);
export const rejected = (val) => Promise.reject(val);
